import React from 'react';

import { UpliftIndex, UpliftIndexRate } from '@/graphql/contracts/_generated_/contracts';
import { LineChart } from '@/components/common/LineChart/LineChart';
import styles from '../uplift-rates.module.scss';

interface GraphTabProps {
  selectedIndex: UpliftIndex | null;
}

export const GraphTab: React.FC<GraphTabProps> = ({ selectedIndex }) => {
  if (!selectedIndex) {
    return (
      <div className={styles.emptyState}>
        <div className={styles.emptyStateContent}>
          <span className={styles.emptyStateIcon}>📊</span>
          <h3>Select an Index to View Graph</h3>
          <p>Please select a region and index from the dropdowns above to view the rate trends.</p>
        </div>
      </div>
    );
  }

  const rates = (selectedIndex.upliftIndexRates || [])
    .filter(rate => rate !== null)
    // Convert to percentage for display
    .map(indexRate => ({ ...indexRate, rate: indexRate!.rate * 100 })) as UpliftIndexRate[]; 

  return (
    <div className={styles.graphTab}>
      <div className={styles.graphHeader}>
        <h3>📈 {selectedIndex.name} Rate Trends</h3>
        <div className={styles.indexInfo}>
          <span className={styles.dataPoints}>
            {rates.length} data points
          </span>
        </div>
      </div>
      
      <LineChart 
        data={rates}
        height={500}
      />
      
    </div>
  );
};
